<template>
  <div>
    <img
      :src="preview || src"
      :width="width"
      :height="height"
      @error="setAltImage"
      :alt="alt"
      :loading="loading"
      class="image-component"
      @click="open = true"
    />
    <BaseModal v-model="open" @close="open = false">
      <img :src="src" @error="setAltImage" :alt="alt" :loading="loading" class="full-width-image" />
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'

import altImage from '@/assets/binity.svg'

export default {
  name: 'ImageComponent',
  components: { BaseModal },
  data: () => ({
    open: false,
  }),
  props: {
    alt: { type: String, required: false, default: '' },
    height: { type: String, required: false, default: '50' },
    loading: { type: String, required: false, default: 'lazy' },
    preview: { type: String, required: false },
    src: { type: String, required: true },
    width: { type: String, required: false, default: '' },
  },
  methods: {
    setAltImage(event) {
      event.target.src = altImage
    },
  },
}
</script>

<style lang="scss" scoped>
.image-component {
  max-width: 100%;
  cursor: pointer;
}

.full-width-image {
  width: 100%;
  height: auto;
}
</style>
